import {
  InputProps as NextUIInputProps,
  Input as NextUIInput,
} from "@heroui/react";

export interface InputProps extends NextUIInputProps {}

export const Input = ({ ...props }: InputProps) => {
  return <NextUIInput {...props} />;
};
